/**
 * Signature Footer — Row of signature blocks matching physical form footer
 */

import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const SignatureFooter = ({ signatories = [] }) => {
  const formatDate = (ts) => {
    if (!ts) return null;
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="wrms-signature-footer">
      <div className="wrms-signature-footer-title">Signatures & Acknowledgements</div>
      <div className="wrms-signature-row">
        {signatories.map((sig, index) => (
          <div
            key={index}
            className={`wrms-signature-block ${sig.name ? 'signed' : 'pending-sig'}`}
          >
            <div className="wrms-sig-title">{sig.title}</div>
            {sig.name ? (
              <>
                <div className="text-center">
                  <FaCheckCircle style={{ color: '#059669', fontSize: '0.9rem', marginBottom: '4px' }} />
                  <div className="wrms-sig-name">{sig.name}</div>
                  {sig.date && <div className="wrms-sig-date">{formatDate(sig.date)}</div>}
                </div>
              </>
            ) : (
              <div className="text-center">
                <div className="wrms-sig-empty" />
                <div className="wrms-sig-date" style={{ color: '#94a3b8', fontSize: '0.6rem' }}>
                  Pending
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SignatureFooter;
